import SeguimientoList from "./SeguimientoList.vue";
import SeguimientoForm from "./SeguimientoForm.vue";

export default [
  {
    path: "/seguimientos",
    name: "seguimientos",
    component: SeguimientoList,
    props: true,
    meta: {
      icono: "fal fa-fw fa-clipboard-list",
      esconder: true,
    },
  },
  {
    path: "/seguimientos/form",
    name: "seguimiento",
    component: SeguimientoForm,
    props: true,
    meta: {
      titulo: "Formulario de seguimiento",
      icono: "fal fa-fw fa-file-alt",
      esconder: true,
    },
  },
];
